import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "../../components/oeeDashboard/Layout";
import Production from "./production";
import { theme } from "./styles/theme";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <Routes>
          <Route index element={<Navigate to="production" replace />} />
          <Route path="home" element={<h2>Home</h2>} />
          <Route path="production" element={<Production />} />
          <Route path="inventory" element={<h2>Inventory</h2>} />
          <Route path="quality" element={<h2>Quality</h2>} />
          <Route path="energy" element={<h2>Energy</h2>} />
          <Route path="maintenance" element={<h2>Maintenance</h2>} />
          <Route path="history" element={<h2>History</h2>} />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}
